/**
 * @flow weak
 */


// Consts
export const ON_COST_ITEMS_SUCCESS = 'ON_COST_ITEMS_SUCCESS';
export const ON_COST_ITEMS_ERROR = 'ON_COST_ITEMS_ERROR';
export const ON_MY_TICKETS_MOUNT = 'ON_MY_TICKETS_MOUNT';
export const ON_MY_TICKETS_MOUNT_SUCCESS = 'ON_MY_TICKETS_MOUNT_SUCCESS';
export const ON_MY_TICKETS_MOUNT_ERROR = 'ON_MY_TICKETS_MOUNT_ERROR';
export const ON_MY_PASSES_MOUNT = 'ON_MY_PASSES_MOUNT';
export const ON_MY_PASSES_MOUNT_SUCCESS = 'ON_MY_PASSES_MOUNT_SUCCESS';
export const ON_MY_PASSES_MOUNT_ERROR = 'ON_MY_PASSES_MOUNT_ERROR';
export const ON_MY_TICKETS_PAST_MOUNT_SUCCESS = 'ON_MY_TICKETS_PAST_MOUNT_SUCCESS';
export const ON_MY_TICKETS_PAST_MOUNT_ERROR = 'ON_MY_TICKETS_PAST_MOUNT_ERROR';
export const ON_MY_TICKETS_CURRENT_MOUNT_SUCCESS = 'ON_MY_TICKETS_CURRENT_MOUNT_SUCCESS';
export const ON_MY_TICKETS_CURRENT_MOUNT_ERROR = 'ON_MY_TICKETS_CURRENT_MOUNT_ERROR';
export const SEND_HOST_MESSAGE = 'SEND_HOST_MESSAGE';
export const SEND_HOST_MESSAGE_SUCCESS = 'SEND_HOST_MESSAGE_SUCCESS';
export const SEND_HOST_MESSAGE_ERROR = 'SEND_HOST_MESSAGE_ERROR';
export const SET_HOST_ID = 'SET_HOST_ID';
export const SET_REFUND_MESSSAGE = 'SET_REFUND_MESSSAGE';
export const SET_REFUND_PAGE_LINK = 'SET_REFUND_PAGE_LINK';
export const CANCEL_ORDER = 'CANCEL_ORDER';
export const CANCEL_ORDER_SUCCESS = 'CANCEL_ORDER_SUCCESS';
export const CANCEL_ORDER_ERROR = 'CANCEL_ORDE_ERROR';
export const SET_TICKET_ID = 'SET_TICKET_ID';
export const SET_COST_ITEM = 'SET_COST_ITEM';
export const TRANSFER_TICKET = 'TRANSFER_TICKET';
export const TRANSFER_TICKET_SUCCESS = 'TRANSFER_TICKET_SUCCESS';
export const TRANSFER_TICKET_ERROR = 'TRANSFER_TICKET_ERROR';
export const TRANSFER_TICKET_RESET = 'TRANSFER_TICKET_RESET';
export const RESEND_TICKET_TRANSFER = 'RESEND_TICKET_TRANSFER';
export const RESEND_TICKET_TRANSFER_SUCCESS = 'RESEND_TICKET_TRANSFER_SUCCESS';
export const RESEND_TICKET_TRANSFER_ERROR = 'RESEND_TICKET_TRANSFER_ERROR';
export const CANCEL_TICKET_TRANSFER = 'CANCEL_TICKET_TRANSFER';
export const CANCEL_TICKET_TRANSFER_SUCCESS = 'CANCEL_TICKET_TRANSFER_SUCCESS';
export const CANCEL_TICKET_TRANSFER_ERROR = 'CANCEL_TICKET_TRANSFER_ERROR';
export const ON_COST_ITEM_UPDATE = 'ON_COST_ITEM_UPDATE';
export const SHOW_BANNER = 'SHOW_BANNER';
export const CLEAR_BANNER = 'CLEAR_BANNER';
export const SHOW_FLASH = 'SHOW_FLASH';
export const CLEAR_FLASH = 'CLEAR_FLASH';
export const UPDATE_INPUT_FIELD = 'UPDATE_INPUT_FIELD';
export const STOP_COST_ITEM_SYNC = 'STOP_COST_ITEM_SYNC';
export const SET_GUEST_HOST_FIELDS = 'SET_GUEST_HOST_FIELDS';
export const SET_BUYER_HOST_FIELDS = 'SET_BUYER_HOST_FIELDS';
export const UPDATE_GUEST_HOST_FIELDS = 'UPDATE_GUEST_HOST_FIELDS';
export const UPDATE_BUYER_HOST_FIELDS = 'UPDATE_BUYER_HOST_FIELDS';
export const UPDATE_TICKET_HOST_FIELDS = 'UPDATE_TICKET_HOST_FIELDS';
export const UPDATE_TICKET_HOST_FIELDS_SUCCESS = 'UPDATE_TICKET_HOST_FIELDS_SUCCESS';
export const UPDATE_TICKET_HOST_FIELDS_ERROR = 'UPDATE_TICKET_HOST_FIELDS_ERROR';
export const UPDATE_COST_ITEM_HOST_FIELDS = 'UPDATE_COST_ITEM_HOST_FIELDS';
export const UPDATE_COST_ITEM_HOST_FIELDS_SUCCESS = 'UPDATE_COST_ITEM_HOST_FIELDS_SUCCESS';
export const UPDATE_COST_ITEM_HOST_FIELDS_ERROR = 'UPDATE_COST_ITEM_HOST_FIELDS_ERROR';
export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const PAGINATION_MORE_ORDERS = 'PAGINATION_MORE_ORDERS';
export const PAGINATION_SET_PAGE = 'PAGINATION_SET_PAGE';
export const TOGGLE_PASS_OPEN = 'TOGGLE_PASS_OPEN';
export const TOGGLE_PASS_CLOSED = 'TOGGLE_PASS_CLOSED';
export const ON_TOGGLE_PASS_SUCCESS = 'ON_TOGGLE_PASS_SUCCESS';
export const ON_TOGGLE_PASS_ERROR = 'ON_TOGGLE_PASS_ERROR';
export const ON_REQUEST_MORE_COST_ITEMS = 'ON_REQUEST_MORE_COST_ITEMS';
export const ON_REFRESH_TICKET_SUCCESS = 'ON_REFRESH_TICKET_SUCCESS';
export const BOOKING_PROTECTION = 'BOOKING_PROTECTION';

// Actions
export const onMyTicketsMount = () => {
  return {
    type: ON_MY_TICKETS_MOUNT
  };
};

export const onRequestMoreCostItems = (ticketId) => {
  return {
    type: ON_REQUEST_MORE_COST_ITEMS,
    payload: ticketId
  };
};

export const onMyPassesMount = () => {
  return {
    type: ON_MY_PASSES_MOUNT
  };
};

export const stopCostItemSync = () => {
  return {
    type: STOP_COST_ITEM_SYNC
  };
};

export const clearFlash = () => {
  return {
    type: CLEAR_FLASH
  };
};

export const showFlash = (level: string, message: string) => {
  return {
    type: ADD_FLASH_MESSAGE,
    payload: {
      level,
      message
    }
  };
};

export const clearBanner = () => {
  return {
    type: CLEAR_BANNER
  };
};

export const showBanner = (level: string, message: string, values: Object) => {
  return {
    type: SHOW_BANNER,
    payload: {
      level,
      message,
      values,
    }
  };
};

export const setHostId = (hostId) => {
  return {
    type: SET_HOST_ID,
    payload: {
      hostId
    }
  };
};

export const setTicketId = (ticketId) => {
  return {
    type: SET_TICKET_ID,
    payload: {
      ticketId
    }
  };
};

export const setCostItem = (costItemId) => {
  return {
    type: SET_COST_ITEM,
    payload: {
      costItemId
    }
  };
};

export const setRefundPageLink = (link) => {
  return {
    type: SET_REFUND_PAGE_LINK,
    payload: {
      link
    }
  };
};

export const updateInput = (input: string, value: string) => {
  return {
    type: UPDATE_INPUT_FIELD,
    payload: {
      input,
      value
    }
  };
};


//
// Cancel Order actions
//
export const cancelOrder = () => {
  return {
    type: CANCEL_ORDER
  };
};


//
// Request Refund actions
//
export const requestRefund = (hostId, message, link) => {
  return {
    type: SEND_HOST_MESSAGE,
    payload: {
      hostId,
      message,
      link
    }
  };
};

export const setRefundMessage = (message) => {
  return {
    type: SET_REFUND_MESSSAGE,
    payload: {
      message
    }
  };
};

//
// Transfer Ticket actions
//
export const transferTicket = () => {
  return {
    type: TRANSFER_TICKET
  };
};

export const resendTicketTransfer = () => {
  return {
    type: RESEND_TICKET_TRANSFER
  };
};

export const cancelTicketTransfer = () => {
  return {
    type: CANCEL_TICKET_TRANSFER
  };
};

//
// Edit Guest Info
//
export const setGuestHostFields = (hostFields: Array<Object>) => {
  return {
    type: SET_GUEST_HOST_FIELDS,
    payload: {
      hostFields
    }
  };
};

export const updateGuestHostFields = (id: string, value: string) => {
  return {
    type: UPDATE_GUEST_HOST_FIELDS,
    payload: {
      id,
      value
    }
  };
};

export const updateCostItemHostFields = () => {
  return {
    type: UPDATE_COST_ITEM_HOST_FIELDS
  };
};

//
// Edit Buyer Info
//
export const setBuyerHostFields = (hostFields: Array<Object>) => {
  return {
    type: SET_BUYER_HOST_FIELDS,
    payload: {
      hostFields
    }
  };
};

export const updateBuyerHostFields = (id: string, value: string) => {
  return {
    type: UPDATE_BUYER_HOST_FIELDS,
    payload: {
      id,
      value
    }
  };
};

export const updateTicketHostFields = () => {
  return {
    type: UPDATE_TICKET_HOST_FIELDS
  };
};

//
// Pagination
//
export const getMoreOrders = (type, offset) => {
  return {
    type: PAGINATION_MORE_ORDERS,
    payload: {
      isCurrentOrPast: type,
      offset
    }
  };
};

export const setPaginationPage = (type, page) => {
  return {
    type: PAGINATION_SET_PAGE,
    payload: {
      isCurrentOrPast: type,
      page
    }
  };
};


// Passes
export const togglePassOpen = (id) => {
  return {
    type: TOGGLE_PASS_OPEN,
    payload: {
      id
    }
  };
};

export const togglePassClosed = id => {
  return {
    type: TOGGLE_PASS_CLOSED,
    payload: { id }
  };
};

export const resetTicketTransfer = () => {
  return {
    type: TRANSFER_TICKET_RESET
  };
};

//
// Booking Protection Order actions
//
export const bookingProtection = () => {
  return {
    type: BOOKING_PROTECTION
  };
};



// WEBPACK FOOTER //
// ./src/modules/my-tickets/actions.js